<script setup>
  import { computed } from 'vue';

  const checkboxValue = defineModel('modelValue');

  const props = defineProps({
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['medium', 'small', 'large'].includes(value);
      }
    },
  })

  const sizesMap = {
    medium: {
      width: '22px',
      svgWidth: '14',
      borderRadius: '3px',
    },
    small: {
      width: '15px',
      svgWidth: '9',
      borderRadius: '2px',
    },
    large: {
      width: '29px',
      svgWidth: '19',
      borderRadius: '4px',
    },
  }

  const computedSize = computed(() => {
    return sizesMap[props.size];
  })

  const containerStyle = computed(() => {
    return {
      '--container-width': computedSize.value.width,
      '--border-radius': computedSize.value.borderRadius
    }
  })

</script>

<template>
  <div
    @click="checkboxValue = !checkboxValue"
    class="checkbox-container"
    :class="size"
    :style="containerStyle"
  >
    <svg
      v-if="checkboxValue"
      :width="computedSize.svgWidth"
      :height="computedSize.svgWidth"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 0.5C0.895431 0.5 0 1.39543 0 2.5V12.5C0 13.6046 0.89543 14.5 2 14.5H12C13.1046 14.5 14 13.6046 14 12.5V2.5C14 1.39543 13.1046 0.5 12 0.5H2ZM10.5205 4.71827L5.83756 9.40123L4.32948 7.89316C4.18397 7.74764 3.99877 7.67489 3.77388 7.67489C3.54899 7.67489 3.36379 7.74764 3.21827 7.89316C3.07276 8.03868 3 8.22388 3 8.44877C3 8.67365 3.07276 8.85886 3.21827 9.00437L5.28195 11.068C5.44069 11.2268 5.6259 11.3062 5.83756 11.3062C6.04921 11.3062 6.23442 11.2268 6.39316 11.068L11.6317 5.82948C11.7772 5.68397 11.85 5.49877 11.85 5.27388C11.85 5.04899 11.7772 4.86379 11.6317 4.71827C11.4862 4.57276 11.301 4.5 11.0761 4.5C10.8512 4.5 10.666 4.57276 10.5205 4.71827Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>

  .checkbox-container {
    color: var(--teal-400);
    border: 2px solid currentColor;
    width: var(--container-width);
    height: var(--container-width);
    border-radius: var(--border-radius);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

</style>